import { render, staticRenderFns } from "./donut-chart.component.vue?vue&type=template&id=66961a48&scoped=true"
import script from "./donut-chart.component.ts?vue&type=script&lang=ts&external"
export * from "./donut-chart.component.ts?vue&type=script&lang=ts&external"
import style0 from "./donut-chart.component.vue?vue&type=style&index=0&id=66961a48&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66961a48",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/foex-3r/foex-3r-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66961a48')) {
      api.createRecord('66961a48', component.options)
    } else {
      api.reload('66961a48', component.options)
    }
    module.hot.accept("./donut-chart.component.vue?vue&type=template&id=66961a48&scoped=true", function () {
      api.rerender('66961a48', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/shared/charts/donut-chart.component.vue"
export default component.exports